export default "__VITE_ASSET__CzFLZf_L__"